import type { ISourceMeta } from '@/utils/traffic-source'
import { useWapListingDetailVersionState } from '@/utils/wap-listing-detail-version'
import { buildWapProductDetailDeepLinkSourceQuery } from '@/plugins/utils'

/** 商详页各导流入口对应的 Adjust 追踪码（adj_t） */
export type ProductDeepLinkEntry =
  | 'top-banner'      // 顶部 banner
  | 'bottom-banner'   // 底部 banner
  | 'side-float'      // 主图右上角悬浮
  | 'voucher'         // 领券
  | 'reviews'         // 评论
  | 'description'     // 详情描述
  | 'purchase'        // 购买按钮（底栏 + SKU 弹窗）

type TrackContext = {
  source?: string
  trafficSourceMeta?: ISourceMeta
}

const PRODUCT_DEEP_LINK_ADJ_T: Record<ProductDeepLinkEntry, string> = {
  'top-banner': '21vewtqg',
  'bottom-banner': '21c3st2a',
  'side-float': '21rju3du',
  voucher: '21vckttd',
  reviews: '21l6qoxr',
  description: '21wwv39h',
  purchase: '21xsr3qd',
}

const getProductDetailDeepLinkTrafficValue = () => {
  const version = useWapListingDetailVersionState().value
  if (version === '2') return 'PurchaseOnlyInAPPproductDetailDeepLink'
  if (version === '1') return 'GeneralproductDetailDeepLink'
  return 'productDetailDeepLink'
}

const buildProductDeepLinkUrl = (
  dataId: number,
  source: 0 | 1,
  adjT: string,
  trafficValue: string,
  getTrackContext?: () => TrackContext | undefined,
) => {
  const route = useRoute()
  const trackContext = getTrackContext?.()

  const { externalLastTrafficSourceType, externalLastTrafficSourceChannel, externalLastTrafficValue } = route.query || {}
  const trackingSource = trackContext?.source || (route.query.source as string) || ''
  const sourceQueryStr = Object.entries(
    buildWapProductDetailDeepLinkSourceQuery(trackingSource, trackContext?.trafficSourceMeta)
  ).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&')

  let url = `https://kilimall.go.link/net.kilimall.shop/deepLink?type=10&data=${dataId}&source=${source}&externalLastTrafficSourceType=organic&externalLastTrafficSourceChannel=WAP&externalLastTrafficValue=${trafficValue}&adj_t=${adjT}&${sourceQueryStr}`
  if (externalLastTrafficSourceType && externalLastTrafficSourceChannel && externalLastTrafficValue) {
    url = `https://kilimall.go.link/net.kilimall.shop/deepLink?type=10&data=${dataId}&source=${source}&externalLastTrafficSourceType=${externalLastTrafficSourceType}_deeplinkFromWap&externalLastTrafficSourceChannel=${externalLastTrafficSourceChannel}_deeplinkFromWap&externalLastTrafficValue=${externalLastTrafficValue}_deeplinkFromWap&adj_t=${adjT}&${sourceQueryStr}`
  }
  return url
}

export const useProductDeepLink = (
  getDataId: () => number,
  getSource: () => 0 | 1,
  getTrackContext?: () => TrackContext | undefined,
) => {
  const getDeepLinkUrl = (entry: ProductDeepLinkEntry) =>
    computed(() => {
      const trafficValue = getProductDetailDeepLinkTrafficValue()
      const adjT = PRODUCT_DEEP_LINK_ADJ_T[entry]
      return buildProductDeepLinkUrl(getDataId(), getSource(), adjT, trafficValue, getTrackContext)
    })

  const handleOpenAppClick = async() => {
    const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

    useRequestLoading().value = true
    let _t = 0
    let isJumpOk = false
    while (!isJumpOk && _t < 3 * 1000) {
      if (document.visibilityState === 'hidden') {
        isJumpOk = true
      }

      await sleep(100)
      _t += 100
    }

    if (!isJumpOk && document.visibilityState === 'visible') {
      window.location.href = 'https://app.adjust.com/1iibnu1z'
    }

    useRequestLoading().value = false
  }

  return { getDeepLinkUrl, handleOpenAppClick }
}
